import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const OLD_MATCH_PATTERN = /https?:\/\/vids\.myspace\.com.*$/i;
const MATCH_PATTERN = /https?:\/\/(www\.)?myspace\.com.*$/i;
const EMBED_PATTERN = /https?:\/\/(www\.)?myspace\.com(\/.+)?\/video\/(.+?)(\/.+)?\/(\d+)/i;

const buildEmbedUrl = (url: string): string => {
	const match = EMBED_PATTERN.exec(url);
	let videoName = '';
	let videoId = '';
	if (match) {
		videoName = match[4] ?? '';
		if (!videoName) {
			videoName = `/${match[3] ?? ''}`;
		}
		videoId = match[5] ?? '';
		if (videoName.length > 0 && !videoName.endsWith('-')) {
			videoName = `${videoName}-`;
		}
	}
	return `//myspace.com/play/video${videoName}${videoId}`;
};

export const matchMyspace: ProviderMatcher = (url, params) => {
	if (OLD_MATCH_PATTERN.test(url)) {
		return {
			kind: 'deprecated',
			provider: 'MySpace',
			embedUrl: url,
			width: '',
			height: '',
			hostLabel: 'myspace-outdated',
		};
	}
	if (!MATCH_PATTERN.test(url)) {
		return null;
	}
	let normalisedUrl = url;
	if (normalisedUrl.startsWith('/')) {
		normalisedUrl = `https://myspace.com${normalisedUrl}`;
	}
	return {
		kind: 'iframe',
		provider: 'MySpace',
		embedUrl: buildEmbedUrl(normalisedUrl),
		width: withUnit(params.width) ?? '',
		height: withUnit(params.height) ?? '',
	};
};
